import { render, staticRenderFns } from "./ShipmentTypeRow.vue?vue&type=template&id=eccb0e00&"
import script from "./ShipmentTypeRow.vue?vue&type=script&lang=js&"
export * from "./ShipmentTypeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports